import RawEndpoint from '~~/app/base/endpoints/RawEndpoint';

/**
 * Relays a freemium tenant claim to worksite-api. One-off action (not registered in
 * EndpointFactory/ModelType, same convention as RegisterInboundEndpoint). temporaryTenantId
 * is a route segment only, the body is plain `{claim_token}`.
 */
export default class TemporaryTenantClaimEndpoint extends RawEndpoint {
    path = 'tenant/marketplace/temporary-tenants';

    claim(temporaryTenantId: string, claimToken: string): Promise<Response> {
        return this.requestRaw({
            method: 'POST',
            path: `${temporaryTenantId}/-actions/claim`,
            data: {
                claim_token: claimToken,
            },
        });
    }
}
